import { render, staticRenderFns } from "./BranchTransactions.vue?vue&type=template&id=1b676348"
import script from "./BranchTransactions.vue?vue&type=script&lang=js"
export * from "./BranchTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports